<template>
  <basic-input-modal
    @selectedElement="propagateChange"
    :byDefault="getData()"
    :student="studentName"
    :title="title"
    ref="input"
    :options="items"/>
</template>
<script>
import BasicInputModal from './BasicInputModal.vue'
import {componentValues, getDataByValue} from '@/utils/componentsValue'

export default {
  components: { BasicInputModal },
  created: function () {
    this.state = this.$attrs.student ? this.$attrs.student.deposition : this.byDefault
  },
  props: {
    title: {
      type: String,
      default: () => 'Deposición'
    },
    studentName: String
  },
  data: () => ({
    enabled: false,
    byDefault: '0',
    state: '',
    items: componentValues.deposition
  }),
  methods: {
    getData: function () {
      return getDataByValue(this.items, this.state)
    },
    setValue: function (value) {
      this.state = value
      this.$refs.input.setValue(this.getData())
    },
    setEnable: function (value) {
      this.enabled = value
      this.$refs.input.setEnable(value)
      this.enabled ? this.setValue(this.byDefault) : this.setValue('ausente')
    },
    propagateChange: function ({item}) {
      this.state = item.value
      this.$emit('updatedElement',
        { deposition: this.state }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryElements/Deposition.vue